import { render, staticRenderFns } from "./PopularGamesMain.vue?vue&type=template&id=1893ea1d&scoped=true"
import script from "./PopularGamesMain.vue?vue&type=script&lang=js"
export * from "./PopularGamesMain.vue?vue&type=script&lang=js"
import style0 from "./PopularGamesMain.vue?vue&type=style&index=0&id=1893ea1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1893ea1d",
  null
  
)

export default component.exports